import { IPaymentItem } from '../redux/payment/bitrixPayment';

/**
 * Общие типы и хелперы платежей.
 *
 * Выделены из `createPaymentLink.ts`, когда ЮKassa убрали с сайта: сам файл
 * с ЮKassa удалён (вместе с боевым секретным ключом, который лежал в бандле),
 * а типы и описание заказа нужны Т-Кассе.
 */
export interface ICreatePaymentLinkParams {
  totalPrice: number;
  phone: string;
  description: string;
  cardId: string | null;
  items: IPaymentItem[];
  partnerId: string;
  skipTestPhoneCheck?: boolean;
  returnUrl?: string;
  savePaymentMethod?: boolean;
}

export interface ICreatePaymentLinkResult {
  success: boolean;
  paymentId?: string;
  confirmationUrl?: string;
  status?: string;
  hasSavedCard?: boolean;
  error?: any;
  errorMessage?: string;
  guid?: string;
}

/** Человекочитаемое описание заказа для платёжной формы и чека. */
export const getPaymentDescription = (items: IPaymentItem[]): string => {
  const descriptionTemp: string[] = [];

  items.forEach((item) => {
    if (item.itemType === 'rent') {
      if (!descriptionTemp.includes('Аренды')) {
        descriptionTemp.push('Аренды');
      }
    }
    if (item.itemType === 'membership') {
      if (!descriptionTemp.includes('Абонементов')) {
        descriptionTemp.push('Абонементов');
      }
    }
  });

  return descriptionTemp.join(' + ') || 'Товаров';
};
